/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'down': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M512 0C228.693 0 0 228.693 0 512s228.693 512 512 512 512-228.693 512-512S795.307 0 512 0zm276.48 597.333l-235.52 235.52c-10.24 13.654-27.307 20.48-40.96 20.48s-30.72-6.826-40.96-17.066l-235.52-235.52c-20.48-20.48-30.72-44.374-30.72-68.267s10.24-47.787 27.307-64.853c34.133-34.134 95.573-34.134 129.706 0L409.6 512V238.933c0-58.026 44.373-102.4 102.4-102.4s102.4 44.374 102.4 102.4V512l44.373-44.373c34.134-34.134 95.574-34.134 129.707 0 37.547 37.546 37.547 95.573 0 129.706z"/>'
  }
})
